import { graphql } from '@/generated/gql';

export const NEGOTIATION_DEMAND_DELETE_MUTATION = graphql(/* GraphQL */ `
  mutation DemandDelete($id: UUID!) {
    tesseract {
      demand(id: $id) {
        delete
      }
    }
  }
`);
